/**
 * Componente visual de status da solicitação
 *
 * Mostra o estado atual do processo de reserva
 *
 * Exemplo de estados:
 *
 * CRIADA
 * INICIADA
 * AGUARDANDO_PAGAMENTO_TAXA
 * TAXA_PAGA
 * EM_VERIFICACAO
 * RESERVA_CONFIRMADA
 */

import React from "react";
import { Tag } from "antd";

export type StatusSolicitacaoReservaFront =
  | "CRIADA"
  | "INICIADA"
  | "AGUARDANDO_PAGAMENTO_TAXA"
  | "TAXA_PAGA"
  | "EM_VERIFICACAO"
  | "PAGAMENTO_TX_INTERROMPIDO"
  | "RESERVA_CONFIRMADA"
  | "RESERVA_FINALIZADA"
  | "RESERVA_CANCELADA"
  | "SEM_INTERESSE_PERIODO_PROCURADO"
  | "SEM_INTERESSE_PERIODO_ENCONTRADO";

const STATUS_META: Record<
  StatusSolicitacaoReservaFront,
  { color: string; label: string }
> = {
  CRIADA: { color: "default", label: "Criada" },
  INICIADA: { color: "default", label: "Iniciada" },
  AGUARDANDO_PAGAMENTO_TAXA: { color: "gold", label: "Aguardando taxa" },
  TAXA_PAGA: { color: "cyan", label: "Taxa paga" },
  EM_VERIFICACAO: { color: "processing", label: "Em verificação" },
  PAGAMENTO_TX_INTERROMPIDO: {
    color: "orange",
    label: "Pagamento interrompido",
  },
  RESERVA_CONFIRMADA: { color: "green", label: "Reserva confirmada" },
  RESERVA_FINALIZADA: { color: "success", label: "Reserva finalizada" },
  RESERVA_CANCELADA: { color: "red", label: "Reserva cancelada" },
  SEM_INTERESSE_PERIODO_PROCURADO: {
    color: "red",
    label: "Procura encerrada",
  },
  SEM_INTERESSE_PERIODO_ENCONTRADO: {
    color: "blue",
    label: "Buscando outro período",
  },
};

type Props = {
  status?: StatusSolicitacaoReservaFront | null;
};

export default function SolicitacaoReservaStatusTag({ status }: Props) {

  if (!status || !STATUS_META[status]) return null;

  const meta = STATUS_META[status];

  return (
    <Tag color={meta.color} style={{ borderRadius: 999 }}>
      {meta.label}
    </Tag>
  );
}
